import { render, staticRenderFns } from "./EmpQueriesList.vue?vue&type=template&id=24fbe350&"
import script from "./EmpQueriesList.vue?vue&type=script&lang=js&"
export * from "./EmpQueriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports